import AmiStrings from '../strings.js';

export default function AmiSettingsSidebar() {
    var sbName = 'settingsList';
    var body = <div><table /></div>;

    var setTitle;

    return {
        getName: function() { return sbName; },
        isWide: function() { return true; },
        getBody: function() { return body; },
        apply: function(obj) {
            setTitle = obj.setTitle;
        },
        reloadStrings: function() {
            setTitle(AmiStrings.getMenuString('sets'));
        },
    };
};
